export default __webpack_public_path__ + "static/media/EngrenagemIcon.4e10453d.svg";